import React, { Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import NProgress from 'nprogress'
import { Helmet } from 'react-helmet'
import PublicLayout from './Public'
import MainLayout from './Main'
import ErrorBoundary from '../pages/errorHandling'
import { store } from '../index'
import CommonService from '../services/commonService'

const Layouts = {
  public: PublicLayout,
  main: MainLayout,
}

@withRouter
@connect(({ user }) => ({ user }))
class IndexLayout extends React.PureComponent {
  previousPath = ''

  constructor(props) {
    super(props)
    this.CommonService = new CommonService()
  }

  componentDidMount() {
    store.dispatch({
      type: 'user/GETUSERNAME',
      payload: {
        name: localStorage.getItem('username'),
        authenticated: localStorage.getItem('username') !== null,
      },
    })

    let isUserAuthorized
    if (localStorage.getItem('IsUserAuthorized') !== null) {
      isUserAuthorized = this.CommonService.DecryptData(localStorage.getItem('IsUserAuthorized'))
    }
    store.dispatch({
      type: 'user/SETUSERAUTHORIZATION',
      payload: {
        authorized: isUserAuthorized === 'true',
      },
    })
  }

  componentDidUpdate(prevProps) {
    const { location } = this.props
    const { prevLocation } = prevProps
    if (location !== prevLocation) {
      window.scrollTo(0, 0)
    }
  }

  render() {
    const {
      children,
      location: { pathname, search },
      user,
    } = this.props

    // NProgress Management
    const currentPath = pathname + search
    if (currentPath !== this.previousPath) {
      NProgress.start()
    }

    setTimeout(() => {
      NProgress.done()
      this.previousPath = currentPath
    }, 300)

    // Layout Rendering
    const getLayout = () => {
      if (user.authenticated && user.authorized) {
        return 'main'
      }
      return 'public'
    }

    const Container = Layouts[getLayout()]

    const BootstrappedLayout = () => {
      return (
        <Container>
          <ErrorBoundary>{children}</ErrorBoundary>
        </Container>
      )
    }

    return (
      <Fragment>
        <Helmet titleTemplate="Ripple Secure | %s" title="Admin" />
        {BootstrappedLayout()}
      </Fragment>
    )
  }
}

export default IndexLayout
